__turbopack_context__.v({
  "container": "IntroSection-module-scss-module__DjhohW__container",
  "infoItems": "IntroSection-module-scss-module__DjhohW__infoItems",
  "kicker": "IntroSection-module-scss-module__DjhohW__kicker",
});
